import { useMemo } from "react";
import { useWindowDimensions } from "react-native";

const useMobileScreen = () => {
  const { width } = useWindowDimensions();

  return useMemo(() => {
    return width <= 1280;
  }, [width]);
};

export default useMobileScreen;
